var _LowQualityIndicator;
import ArrowIosRight from '@crehana/icons/outline/ArrowIosRight';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { colors, Switch } from '@crehana/ui';
import { LowQualityIndicator } from "../../ui";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var OptionButton = function OptionButton(_ref) {
  var changeSection = _ref.changeSection,
    onSwitch = _ref.onSwitch,
    id = _ref.id,
    label = _ref.label,
    value = _ref.value,
    hasLowQuality = _ref.hasLowQuality;
  return /*#__PURE__*/_jsxs("button", {
    type: "button",
    className: "bg-transparent focus:outline-none w-full flex items-center justify-between py-16 px-24",
    onClick: changeSection && id ? function () {
      changeSection(id);
    } : onSwitch,
    "aria-label": typeof value === 'string' ? "".concat(label, " - ").concat(value) : label,
    children: [/*#__PURE__*/_jsxs("span", {
      className: "flex items-center font-button text-white mr-8",
      children: [hasLowQuality && (_LowQualityIndicator || (_LowQualityIndicator = /*#__PURE__*/_jsx(LowQualityIndicator, {
        className: "mr-8"
      }))), label]
    }), onSwitch ? /*#__PURE__*/_jsx(Switch, {
      dark: true,
      checked: !!value
    }) : /*#__PURE__*/_jsxs("div", {
      className: "flex items-center",
      children: [value && /*#__PURE__*/_jsx("span", {
        className: "font-body3 text-white mr-4",
        children: value
      }), /*#__PURE__*/_jsx(ArrowIosRight, {
        size: 16,
        color: colors.secondaryLight
      })]
    })]
  });
};
export default OptionButton;